import type { GTMEventGlycerinDisplayLink, GTMEventGlycerinLinkClick } from '@packages/tracking';
import { useTracking } from '@packages/tracking';

export const useInstallmentCalculatorTracking = () => {
  const dispatchTracking = useTracking();

  const label = 'Kredit-Promo';

  const trackGlycerinDisplayLink = () => {
    dispatchTracking<GTMEventGlycerinDisplayLink>({
      event: 'DisplayLink',
      DisplayLinkData: {
        category: 'Ratenelement',
        label,
        target: 'Overlay',
      },
    });
  };

  const trackGlycerinLinkClick = () => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category: 'Ratenrechner',
        label,
      },
    });
  };

  return {
    trackGlycerinDisplayLink,
    trackGlycerinLinkClick,
  };
};
